module.exports = __webpack_public_path__ + "static/img/store2.2db852f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/store2.jpg
// module id = ireO
// module chunks = 1